module.exports = __webpack_public_path__ + "static/media/bug.7d98a92c.png";